/* istanbul ignore file */
import { useState } from 'react';
import { Show } from 'framework/show';
import Indent from 'infrastructure/email/sendEmail/SendForm/Indent';
import useSendEmailService from 'infrastructure/email/sendEmail/sendEmailService';
import { UiThemeOverrider } from 'framework/uiTheme';
import SendEmailButton from 'infrastructure/email/sendEmail/shared/buttons/SendEmailButton';
import EditEmailButton from 'infrastructure/email/sendEmail/shared/buttons/EditEmailButton';
import SendFormPageLayout from 'infrastructure/email/sendEmail/SendForm/SendFormPageLayout';
import { useSendEmailId, useSendEmailUrl } from 'infrastructure/email/sendEmail/sendEmailRouting';
import SendEmailDataFieldLayout from 'infrastructure/email/sendEmail/shared/layouts/SendEmailDataFieldLayout';
import { CommaListField, EmailField, HtmlField, TextField } from 'framework/ui/field';
import { useDocumentUiConfiguration } from 'infrastructure/documentUiConfiguration';

const SendFormPage = () => {
  const { AttachmentsListField } = useDocumentUiConfiguration();
  const [isEditButtonVisible, setIsEditButtonVisible] = useState<boolean>(true);
  const emailId = useSendEmailId();
  const { getData } = useSendEmailService();
  const { getUpdateEntityUrl } = useSendEmailUrl();

  const buttons = [
    <SendEmailButton
      key="send-btn"
      toggleEditButton={setIsEditButtonVisible}
      isEditButtonVisible={isEditButtonVisible}
    />,
    <EditEmailButton key="edit-btn" path={getUpdateEntityUrl(emailId)} isVisible={isEditButtonVisible} />,
  ];

  return (
    <Show getDataMethod={() => getData(emailId)}>
      <UiThemeOverrider
        overriddenLayouts={{
          BaseFieldLayout: SendEmailDataFieldLayout,
        }}
      >
        <SendFormPageLayout buttons={buttons}>
          <EmailField source="recipient" label="To" />
          <TextField source="subject" label="Subject" />
          <CommaListField source="ccs" label="CC" />
          <Indent />
          <HtmlField source="content" label="" />
          <AttachmentsListField label="" source="attachmentIds" />
        </SendFormPageLayout>
      </UiThemeOverrider>
    </Show>
  );
};

export default SendFormPage;
